var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferringProviderActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0916 36.2222L22.5 47.1111M22.5 47.1111L28.9084 36.2222M22.5 47.1111V58M32.1126 48.6667H35.3168M8.41189 58H36.5881C40.7986 58 43.865 54.1247 42.7801 50.1745L39.7895 39.2857C39.0415 36.5619 36.5009 34.6667 33.5975 34.6667H11.4025C8.49914 34.6667 5.95854 36.5619 5.21046 39.2857L2.21988 50.1745C1.13499 54.1247 4.20138 58 8.41189 58ZM35.3168 14.4444C35.3168 21.3173 29.5785 26.8889 22.5 26.8889C15.4215 26.8889 9.68323 21.3173 9.68323 14.4444C9.68323 7.57157 15.4215 2 22.5 2C29.5785 2 35.3168 7.57157 35.3168 14.4444Z",
    stroke: "#3059A5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferringProviderActive);
export default __webpack_public_path__ + "static/media/referringProvider-active.941e31e65fbd35e8294e33c174cd8919.svg";
export { ForwardRef as ReactComponent };